import React from "react"
import styled from "styled-components"

import ScrollingSimpleBoard from "../../../obsSources/ScrollingSimpleBoard"
import { defaultSortedPlayers } from "../../../utils"

const DetailedBoardPreview = ({ players, event }) => (
  // <SimpleBoardWrapper className='player-panel simple-board'>
  //   <ScrollingSimpleBoard disableScrolling players={defaultSortedPlayers(players).slice(0, 8)} totalChapterCount={event.chapterNames.length}/>
  // </SimpleBoardWrapper>
  <>The whole fricking thing</>
)

export default DetailedBoardPreview

const SimpleBoardWrapper = styled.div`
  ${'' /* width: 210px; */}
  .row {
    font-size: 1em;
    &:first-child {
      padding-top: 5px;
    }
  }


  .flag {
    margin-right: auto;
  }

  ${'' /* padding-top: 20px; */}
  ${'' /* background: #141732; */}
  border-radius: 12px;
  border: 3px solid #aaa;
  ${'' /* height: 225.8px; */}
    ${'' /* min-height: 441px; */}
  .simple-board-wrapper {
    margin: auto;
  }

  .row {
    padding-top: 2px;
    padding-bottom: 2px;
  }

`
